import { changePassword } from "../../js/api/profile.js";
import { _t } from "../../services/TranslationService.js";

let ChangePassword = {
  render: async () => {
    let view = /*html*/ `
            <div class="changePasswordHeader m-t-6">
                 <a class="backBtn">
                    <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#939393" d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
                </a>
                 <span>${_t("Ndrysho Fjalekalimin")}</span>
           </div>
           <div class="changePasswordWrapper m-t-6">
                <div class="changePasswordHolder">
                  <!--   <p>Notice! Use 1 uppercase Letter, minimum 8 characters bla bla.</p>-->
                    <input type="password" placeholder="${_t("Fjalekalimi i vjeter")}" id="oldPassword">
<!--                    <span class="errorMsg">Error Old Password</span>-->
                    <input type="password" placeholder="${_t("Fjalekalimi i ri")}" id="newPassword">
<!--                    <span class="errorMsg">No Error</span>-->
                    <input type="password" placeholder="${_t("Perserit Fjalekalimin")}" id="repeatPassword">
<!--                    <span class="errorMsg">No Error</span>-->
                    <a class="changePassowrdBtn" id="changePassowrdBtn">${_t("Regjistro")}</a>
                </div>
            </div>
       `;
    return view;
  },
  after_render: async () => {
    const submitBtn = document.getElementById("changePassowrdBtn");

    submitBtn.addEventListener("click", async () => {
      const old_password = document.getElementById("oldPassword").value;
      const new_password = document.getElementById("newPassword").value;
      const new_password_repeat =
        document.getElementById("repeatPassword").value;

      // Check if password has 8 characters, and includes at least one number and one letter
      if (
        new_password.length < 8 ||
        !/\d/.test(new_password) ||
        !/[a-zA-Z]/.test(new_password)
      ) {
        alert(
          _t(
            "Password must be at least 8 characters long and include at least one number!",
          ),
        );
        return;
      }

      // Check if password have at least one special character
      if (!/[!@#$%^&*]/.test(new_password)) {
        alert(_t("Password must include at least one special character!"));
        return;
      }

      var res = await changePassword({
        new_password,
        new_password_repeat,
        old_password,
      });

      if (res && res.message) {
        alert(res.message);
      }
    });
  },
};

export default ChangePassword;
